import React, { useState } from 'react';
import { EditFaq } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import * as yup from 'yup';
import { SupportController } from '../../controllers';

const EditFaqContainer = ({closeModal, data, items}) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = () => {
        return (
            yup.object().shape({
                question: yup.string().required("Enter FAQ"),               
                answer: yup.string().required("Enter answer"),  
                faqCategory: yup.string().required("Select FAQ category"),             
            })
        )
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            question: values.question,
            answer: values.answer, 
            faqCategory: values.faqCategory,          
        }
        const { status, errorMessage } = await SupportController.editFaq(            
            payload,
            items._id
            );

        if (status === constant.Success) {
            SupportController.getFaqs();           
            MimaToastUtil.success({ message: constant.Success })          
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <EditFaq
        loading={loading}
        onSubmit={onSubmit}
        closeModal={closeModal}
        data={data}
        items={items}
        validationSchema={validationSchema}
        />
    )
}
export default EditFaqContainer;